// React libraries
import React from "react";
// Custom Styles
import { useStyles } from "./ScanContentBarStyles";
// Material-UI Core
import { Grid } from "@mui/material";
export const ScanContentBar = (props) => {
    const classes = useStyles(props);
    const { text, onClick, applyBorderRadius } = props;
    return (React.createElement(Grid, { container: true, className: classes.scanContentBar, onClick: onClick },
        React.createElement(Grid, { className: classes.content, item: true, md: 6 }, text)));
};
ScanContentBar.defaultProps = {
    applyBorderRadius: true,
    onClick: () => { }
};
export default React.memo(ScanContentBar);
